import { assessmentSectionToPaginatedSections } from "app/features/assessments/utils/utils";
import { AssessmentModel } from "app/services/api/types/forms/models/AssessmentModel";
import { AssessmentSectionModel } from "app/services/api/types/forms/models/AssessmentSectionModel";
import { useMemo, useState } from "react";

interface Props {
  form: AssessmentModel;
}

export function useAssessmentPagination({ form }: Props) {
  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const paginatedForm = useMemo(
    () =>
      assessmentSectionToPaginatedSections<AssessmentSectionModel>(
        form?.sections ?? [],
      ).paginatedSections,
    [form],
  );

  const sections = useMemo(() => {
    return paginatedForm[currentPageIndex]?.sections ?? [];
  }, [paginatedForm, currentPageIndex]);

  return {
    sections,
    currentPageIndex,
    setCurrentPageIndex,
    totalPages: paginatedForm.length,
  };
}
